import { createContext, ReactNode, useContext } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { documentSchemaService, IApiDocumentSchema } from '@tap/data-providers';
import { UseFetchDataState, useFetchData } from '@tap/mui-ui';

/*
*   Провайдер для Documents
*/

export type DocumentSchemaContextValue = {
    schemaList: IApiDocumentSchema[],
    schemaListState: UseFetchDataState<IApiDocumentSchema[]>,
}

export const DocumentSchemaContext = createContext<DocumentSchemaContextValue | null>(null);

export type DocumentSchemaProviderOptions = {
    children?: ReactNode,
    documentCodes?: string[],
}


export const DocumentSchemaProvider = ({ documentCodes, children }: DocumentSchemaProviderOptions): JSX.Element => {
    const [schemaListState, schemaList] = useFetchData(
        () => documentSchemaService.getList(documentCodes), [documentCodes], { defaultValue: [] as IApiDocumentSchema[] });

    return (
        <DocumentSchemaContext.Provider
            value={{
                schemaList,
                schemaListState,
            }}
        >
            {!schemaListState.isReady && (
                <Backdrop open={true} invisible={true}>
                    <CircularProgress color='inherit' />
                </Backdrop>
            )}
            {schemaListState.isReady && children}
        </DocumentSchemaContext.Provider>
    );
};

export const useDocumentSchemaContext = (): DocumentSchemaContextValue => {
    const context = useContext(DocumentSchemaContext);

    if (context == null) {
        throw new Error('No DocumentSchemaContext provided');
    }

    return context;
};

export const useDocuemtnSchema = (documentCode: string): IApiDocumentSchema => {
    const { schemaList } = useDocumentSchemaContext();
    const result = schemaList?.find(dc => dc.documentCode === documentCode.toUpperCase());

    if (!result) {
        throw new Error(`Document with code ${documentCode} not found.`);
    }

    return result;
}
